import { render, staticRenderFns } from "./AddGPPage.vue?vue&type=template&id=79a150ea&"
import script from "./AddGPPage.vue?vue&type=script&lang=js&"
export * from "./AddGPPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports